<template>
  <div>
    <v-layout wrap>
      <v-flex sm12>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-form ref="form" @submit.prevent="send">
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="work"
                      dark
                      label="Número de empleado"
                      :rules="requiredRule"
                      type="number"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field
                      v-model="password"
                      dark
                      label="Contraseña"
                      :rules="requiredRule"
                      type="password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="d-flex flex-row-reverse">
                    <v-btn type="submit" rounded class="white" style="padding: 0 1rem">Acceder</v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>

    <v-snackbar v-model="snackbar" top right>
      {{ message }}
      <v-btn color="pink" text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      requiredRule: [v => !!v || "Este campo es obligatorio"],
      work: "",
      password: "",
      snackbar: false,
      message: "",
      host: process.env.VUE_APP_HOST
    };
  },
  methods: {
    send() {
      if (this.$refs.form.validate()) {
        let data = {
          work: this.work,
          password: this.password,
          idUser: this.$route.params.idUser
        };

        axios
          .post(
            this.host + "/questionnaire/login.php",
            this.createFormData(data)
          )
          .then(response => {
            this.message = response.data.message;
            this.snackbar = true;
            let participant = response.data.participantData;

            if (response.data.status) {
              participant = response.data.participantData;
            }

            if (response.data.status && !participant.resolved) {
              sessionStorage.setItem(
                "participant",
                JSON.stringify(participant)
              );
              this.$router.push({ name: "helpquestionnaire" });
            } else {
              this.message = response.data.message;
              this.snackbar = true;
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    sendAuto() {
      let data = {
        work: this.$route.params.work,
        password: this.$route.params.password,
        idUser: this.$route.params.idUser
      };

      axios
        .post(this.host + "/questionnaire/login.php", this.createFormData(data))
        .then(response => {
          this.message = response.data.message;
          this.snackbar = true;
          let participant = null;
          if (response.data.status) {
            participant = response.data.participantData;
          }

          if (response.data.status && !participant.resolved) {
            sessionStorage.setItem("participant", JSON.stringify(participant));
            this.$router.push({ name: "helpquestionnaire" });
          } else {
            this.message = response.data.message;
            this.snackbar = true;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  },
  mounted() {
    if (
      this.$route.params.work != null &&
      this.$route.params.password != null
    ) {
      this.sendAuto();
    }
  }
};
</script>